import type { AntallUlesteRepresentertGuid } from '../types/entities/hendelsesmeny.v2entities';

import { fallbackHeaderFooter } from '@helsenorge/core-cms/header-skeleton/data';
import type { HeaderFooterDTO } from '@helsenorge/core-cms/types/entities/cms.v1entities';
import type {
  AuthenticatedTiles,
  PublicTiles,
} from '@helsenorge/core-cms/types/entities/helsenorge.corefrontend.internalapi.entities.entities';
import type LanguageLocales from '@helsenorge/core-utils/constants/languages';
import type { Personverninnstilling } from '@helsenorge/framework-utils/hn-user';

export interface GlobalState {
  loading?: LoadingState;
  error?: ErrorState;
  isAuthorized?: boolean;
  isMinHelseTjenester?: boolean;
  bruker?: BrukerState;
  language?: LanguageLocales;
  headerFooter: HeaderFooterDTO;
  tiles?: PublicTiles[] | AuthenticatedTiles[] | null;
  islistenerReady?: boolean;
  /** Antall uleste for den personen som er valgt */
  antallUlesteForValgtRepresentasjon?: number;
  /** Liste med antall uleste per person bruker kan representere */
  antallUlesteForAlleRepresentasjoner?: AntallUlesteRepresentertGuid[];
  /** URL som skal redirectes til etter å ha valgt representasjon i personvelgeren i menyen */
  personvelgerRedirectUrl?: string;
}

export interface ErrorState {
  global?: string;
  profileError?: string;
  hendelseError?: string;
  kunAntallUlesteError?: string;
  headerFooterError?: string;
  tilesError?: string;
  antallUlesteError?: string;
}

export interface LoadingState {
  global?: boolean;
  isKunAntallUlesteLoading?: boolean;
  isHeaderFooterLoading?: boolean;
  isTilesLoading?: boolean;
  isAntallUlesteLoading?: boolean;
}

export interface BrukerState {
  visPersonvelger?: boolean;
  navn?: string;
  sistInnlogget?: string;
  representertBruker?: string;
  erRepresentasjon?: boolean;
  erMellom12Og16?: boolean;
  harRepresentasjon?: boolean;
  harBarnMedAnnenAdresse?: boolean;
  harBarnUnder16UtenForeldreansvar?: boolean;
  harBarnOver11?: boolean;
  harBarnOver12?: boolean;
  harBarnOver16?: boolean;
  scopes?: string[];
  personverninnstillinger?: Personverninnstilling[];
}

// This is the default state when initialized
export const initialState: GlobalState = {
  loading: {
    global: false,
    isKunAntallUlesteLoading: false,
    isHeaderFooterLoading: false,
    isTilesLoading: false,
  },
  error: {
    global: undefined,
    profileError: undefined,
    hendelseError: undefined,
    kunAntallUlesteError: undefined,
  },
  isAuthorized: false,
  isMinHelseTjenester: false,
  bruker: undefined,
  tiles: null,
  antallUlesteForValgtRepresentasjon: 0,
  islistenerReady: false,
  headerFooter: fallbackHeaderFooter,
};
